import { styled } from "@stitches/react";
import { Layout } from "antd";

export const StyledPageHeader = styled(Layout.Header, {
  paddingInline: "var(--space-24)",
  height: "72px",
  position: "sticky",
  top: 0,
});
export const StyledPageContent = styled(Layout.Content, {
  overflow: "auto",
  background: "var(--background-1)",
  variants: {
    height: {
      page: {
        height: "calc(100vh - var(--app-header-height))",
      },
    },
  },
});
